import React from 'react';
import { NFL_TEAMS } from '../data/nflTeams';
import { useDarkMode } from '../contexts/DarkModeContext';

function NFLBackground({ children }) {
  // Extrahiere alle Logos
  const teamLogos = Object.values(NFL_TEAMS).map(team => team.logo);
  const { darkMode } = useDarkMode();
  
  // Wiederhole 4x für mehr Coverage
  const allLogos = [
    ...teamLogos,
    ...teamLogos,
    ...teamLogos,
    ...teamLogos
  ];

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* HINTERGRUND mit Team-Logos */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        opacity: darkMode ? 0.18 : 0.25,
        pointerEvents: 'none',
        overflow: 'hidden'
      }}>
        {/* Team-Logos Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(9, 1fr)', // 12 Spalten statt 8
          gap: '20px',
          padding: '10px',
          transform: 'rotate(-10deg) scale(1.3)'
        }}>
          {allLogos.map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt=""
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '120px', // Kleinere Logos
                opacity: darkMode ? 0.4 : 0.5, // ← Noch dunkler im Dark Mode
                filter: darkMode ? 'brightness(0.7)' : 'none' // ← Dimmt die Logos
              }}
            />
          ))}
        </div>
      </div>
      
      {/* Content */}
      {children}
    </div>
  );
}

export default NFLBackground;